<div class="container default-background" cdkScrollable>
  <div class="content">
    <h1 class="warn">Doesn’t seem like this page exists.</h1>
    <img src="assets/img/404.svg" alt="not found" />
    <a class="link" routerLink="/rides">Go to Ride Requests Page</a>
  </div>
</div>
